import axios from 'axios'
import { Message } from 'element-ui'
/*import { getSystemId } from '@/utils/systemInfo'*/

// create an axios instance
const service = axios.create({
  baseURL: config.VUE_APP_BASE_API/*process.env.VUE_APP_BASE_API*/, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 3000000 // request timeout
})

// request interceptor
/*service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers['systemId'] = getSystemId()
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)*/

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.request.responseType === 'blob') {
      return response
    }

    const res = response.data
    if (res.resultCode === '99') {
      const msg = res.resultDesc ? res.resultDesc : '服务异常，请稍后重试'
      Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    /*  Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })*/
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js